module.exports = __webpack_public_path__ + "static/media/close.936d29e2.svg";